import { useContext } from 'react';
import { Navigate, Route } from 'react-router-dom';

import { RedirectContext } from 'context/Redirect';
import { FaroRoutes } from 'utils/faro';

import { Instance } from './Instance';
import { Portal } from './Portal';
import { PostSSO } from './PostSSO';
import { PostSSOError } from './PostSSOError';
import { redirectToRoutes } from './routes';
import { To } from './To';

export const RedirectTo = () => {
  const [{ instance, to }] = useContext(RedirectContext);

  const defaultRoute = to ? redirectToRoutes.to : instance ? redirectToRoutes.instanceHome : redirectToRoutes.portal;

  return (
    <FaroRoutes>
      <Route path={redirectToRoutes.relative.instanceHome} element={<Instance />} />
      <Route path={redirectToRoutes.relative.instanceOnboarding} element={<Instance />} />
      <Route path={redirectToRoutes.relative.portal} element={<Portal />} />
      <Route path={redirectToRoutes.relative.to} element={<To />} />
      <Route path={redirectToRoutes.relative.postSso} element={<PostSSO />} />
      <Route path={redirectToRoutes.relative.postSsoError} element={<PostSSOError />} />
      <Route index element={<Navigate replace to={defaultRoute} />} />
    </FaroRoutes>
  );
};
